import { getAngularService, toRequiredPositiveInteger } from '../Utilities';

interface UserConfigEntry {
  config_key: string;
  config_value: string;
}

interface UserConfigResource {
  get(params: { userId: number }): { $promise: PromiseLike<UserConfigEntry[]> };
  save(params: { userId: number; config: { defaultReportCourse: string } }): { $promise: PromiseLike<UserConfigEntry[]> };
}

function getUserConfig(): UserConfigResource {
  const service = getAngularService<UserConfigResource>('UserConfig');
  if (!service) {
    throw new Error('User configuration service is unavailable');
  }
  return service;
}

export async function getSavedCollectionIds(userId: number | string): Promise<string[]> {
  const validatedUserId = toRequiredPositiveInteger(userId, 'userId');
  const entries = await getUserConfig().get({ userId: validatedUserId }).$promise;
  const saved = entries.find((entry) => entry.config_key === 'defaultReportCourse');
  if (!saved) {
    return [];
  }
  const ids: unknown = JSON.parse(saved.config_value);
  if (!Array.isArray(ids) || !ids.every((id): id is string => typeof id === 'string')) {
    throw new Error('Invalid saved report collection selection');
  }
  return ids;
}

export async function saveCollectionIds(userId: number | string, collectionIds: string[]): Promise<void> {
  const validatedUserId = toRequiredPositiveInteger(userId, 'userId');
  // Keep the original key and JSON format so existing saved selections still work.
  await getUserConfig().save({ userId: validatedUserId, config: { defaultReportCourse: JSON.stringify(collectionIds) } }).$promise;
}
